import { FeedModuleTypeEnum } from "@/common/services/types";
import { HTMLAttributes, PropsWithChildren } from "react";
import { clsx } from "clsx";

interface FeedModuleContainerProps extends HTMLAttributes<HTMLDivElement> {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const FeedModuleContainer = ({
  moduleId,
  moduleType,
  className,
  children,
  ...rest
}: PropsWithChildren<FeedModuleContainerProps>) => {
  return (
    <div
      data-feed-item-id={moduleId}
      data-feed-module-type={moduleType}
      className={clsx("FeedModule", className)}
      {...rest}
    >
      {children}
    </div>
  );
};
